import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-step",
  templateUrl: "./step.component.html",
  styleUrls: ["./step.component.scss"],
})
export class StepComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
